(function() {
    'use strict';
    angular.module('Filters').filter('bbaDate', bbaDate);
    bbaDate.$inject = [];
    function bbaDate() {
        return (strDateOrTimeStamp, withTime = false, dateFormat = 'DD/MM/YYYY', timeZone = null) => {
            if (!strDateOrTimeStamp) return 'N/A';
            if (withTime) dateFormat = `${dateFormat} hh:mmA`;

            if (timeZone)  {
                return moment(strDateOrTimeStamp).utcOffset(timeZone).format(dateFormat);
            }

            return moment(strDateOrTimeStamp).format(dateFormat);
        }
    }
})();



// WEBPACK FOOTER //
// ./js/filters/bbaDate.js